import React from "react";

const LoadingScreenDenda = ({ text = "", className = "" }) => {
  return (
    <div
      className={`
        fixed inset-0 z-50
        flex min-h-screen w-full flex-col items-center justify-center
        bg-background/95 backdrop-blur-sm supports-[backdrop-filter]:bg-background/60
        ${className}
      `}
    >
      <div className="relative flex items-center justify-center" role="status" aria-label="Loading">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500"></div>
      </div>

      {text && (
        <div className="mt-4 text-center text-lg font-medium text-foreground/80">
          <span>{text}</span>
        </div>
      )}
    </div>
  );
};

export default LoadingScreenDenda;
